export const LISTING_KEY = 'LISTINGS_BOT_SAVED_LISTINGS'
export const JWT_TOKEN_KEY = 'LISTINGS_BOT_JWT_TOKEN'
// Same as JWT_TOKEN_KEY. JWT_TOKEN_KEY will be deprecated soon
export const ACCESS_TOKEN = 'LISTINGS_BOT_ACCESS_TOKEN'
export const EXTENSION_DEBOUNCE_KEY_MAP = 'LISTINGS_BOT_EXTENSION_DEBOUNCE_KEY_MAP'
export const DENVER_PLACE_ID = 'ChIJzxcfI6qAa4cR1jaKJ_j0jhE'
export const SQFT_LOT_LIMIT = 10890
export const ACRES_TO_SQFT_CONVERSION = 43560
